import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=509e385d&scoped=true&"
import script from "./svg-icon.vue?vue&type=script&lang=js&"
export * from "./svg-icon.vue?vue&type=script&lang=js&"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=509e385d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e385d",
  null
  
)

export default component.exports